import { render, staticRenderFns } from "./m-modal-review.vue?vue&type=template&id=e5271c28&scoped=true&"
import script from "./m-modal-review.vue?vue&type=script&lang=js&"
export * from "./m-modal-review.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-review.vue?vue&type=style&index=0&id=e5271c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5271c28",
  null
  
)

export default component.exports